import React from "react";

interface IBoltIconProps extends React.SVGProps<any> {
  width?: number;
  height?: number;
}

function BoltIcon({ width, height, ...props }: IBoltIconProps) {
  return (
    <svg viewBox="0 0 512 512" height={height ? height : 24} width={width ? width : 24} {...props}>
      <path
        d="M397.241 176.552H276.303L388.414 0H247.172L114.759 264.828h104.166L114.759 512l282.482-335.448z"
        fill="#ecba16"
      />
    </svg>
  );
}

export default BoltIcon;
